import { render, staticRenderFns } from "./ChatPage.vue?vue&type=template&id=2dc191e8&scoped=true&"
import script from "./ChatPage.vue?vue&type=script&lang=js&"
export * from "./ChatPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc191e8",
  null
  
)

export default component.exports